import { render, staticRenderFns } from "./RegistrationCodeErrorDialog.vue?vue&type=template&id=541a0f24&"
import script from "./RegistrationCodeErrorDialog.vue?vue&type=script&lang=js&"
export * from "./RegistrationCodeErrorDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports